import { MapApiProvider, MapProvider } from 'core';
import { Outlet, useOutletContext } from 'react-router-dom';
import { StoreProvider } from 'store';

export const StoreProviderLayout = () => {
  const context = useOutletContext();
  return (
    <MapApiProvider>
      <MapProvider id={'events'}>
        <StoreProvider>
          <Outlet context={context} />
        </StoreProvider>
      </MapProvider>
    </MapApiProvider>
  );
};
